import { isEmpty, isNil } from 'lodash';

export default function WholesalePageForm() {
  const form = document.querySelector('#wholesale-form-2');

  function validateOnSubmit() {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const formEror = form.querySelector('.wholesale-form-2__error-message');
      const submitButton = form.querySelector('.wholesale-form--submit-btn-2');
      const submitButtonLoader = form.querySelector('.wholesale-form--submit-btn-2__loader');
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.setAttribute('aria-disabled', 'true');
      submitButtonLoader.removeAttribute('hidden');

      if (!formEror.hasAttribute('hidden')) {
        formEror.setAttribute('hidden', 'hidden');
      }

      const omitFields = ['captcha_settings', 'oid', 'g-recaptcha-response', 'retURL'];
      // Submit the form
      const formData = new FormData(form);
      // check for g-recaptcha-response
      const recaptchaResponse = formData.get('g-recaptcha-response');
      const recaptchaError = form.querySelector('.g-recaptcha-error');
      if (isNil(recaptchaResponse) || isEmpty(recaptchaResponse)) {
        // setStatus('recaptcha', 'Please complete the reCAPTCHA', 'error');
        recaptchaError.removeAttribute('hidden');
        submitButton.removeAttribute('disabled');
        submitButton.removeAttribute('aria-disabled');
        submitButtonLoader.setAttribute('hidden', 'hidden');
        return;
      }
      if (!recaptchaError.hasAttribute('hidden')) {
        recaptchaError.setAttribute('hidden', 'hidden');
      }
      // Remove fields that are not needed for submission
      omitFields.forEach((field) => {
        formData.delete(field);
      });

      fetch(form.action, {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Network response was not ok');
        })
        .then((data) => {
          const { result } = data;
          submitButton.removeAttribute('disabled');
          submitButton.removeAttribute('aria-disabled');
          submitButtonLoader.setAttribute('hidden', 'hidden');
          if (result === 'success') {
            // handle success response
            window.location.href = '/pages/wholesale-program?success=true';
          }
          if (result === 'error') {
            const { error } = data;
            // handle error response
            console.error('Error:', error);
            formEror.removeAttribute('hidden');
            formEror.firstChild.innerText = `Something went wrong. ${data.message}`;
          }
        })
        .catch((error) => {
          submitButton.removeAttribute('disabled');
          submitButton.removeAttribute('aria-disabled');
          submitButtonLoader.setAttribute('hidden', 'hidden');
          // handle error response
          console.error('Error:', error);
          formEror.removeAttribute('hidden');
          formEror.firstChild.innerText = `Something went wrong. ${error}`;
        });
    });
  }

  function init() {
    validateOnSubmit();
  }

  init();
}
